import { createReducer, createAction } from "redux-act";
import * as app from "./app";

const IMPORT_FORM_REQUEST = `${app.NS}account/import_form_request`;
export const IMPORT_FORM_REQUEST_ACTION = createAction(IMPORT_FORM_REQUEST);
const IMPORT_FORM_SUCCESS = `${app.NS}account/import_form_success`;
export const IMPORT_FORM_SUCCESS_ACTION = createAction(
  IMPORT_FORM_SUCCESS,
  data => ({
    data
  })
);
const IMPORT_FORM_FAILURE = `${app.NS}account/import_form_failure`;
export const IMPORT_FORM_FAILURE_ACTION = createAction(IMPORT_FORM_FAILURE);

export const importFormRequest = id => {
  const action = IMPORT_FORM_REQUEST_ACTION(id);
  return action;
};
export const importFormSuccess = data => {
  const action = IMPORT_FORM_SUCCESS_ACTION(data);
  return action;
};

export const importFormFailure = error => {
  const action = IMPORT_FORM_FAILURE_ACTION(error);
  return action;
};



// WEBPACK FOOTER //
// ./src/ducks/import.js